import { render, staticRenderFns } from "./userConsolidate.vue?vue&type=template&id=21ba9948"
import script from "./userConsolidate.vue?vue&type=script&lang=js"
export * from "./userConsolidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports